module.exports = __webpack_public_path__ + "img/logement-etage-intermediaire-supp.441e5abd.png";